export default __webpack_public_path__ + "static/media/light_bulb.d68f883e.svg";